import { useEffect } from 'react';

interface UsePositionsEffectsProps {
  getPositionsHandler: () => Promise<void>;
}

export const usePositionsEffects = ({
  getPositionsHandler,
}: UsePositionsEffectsProps) => {
  useEffect(() => {
    getPositionsHandler();
  }, [getPositionsHandler]);
};
